const deleteVariableModal = {
  bindings: {
    variable: '<',
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/variables/delete-variable-modal/delete-variable-modal.html',
  controller: 'DeleteVariableModalController',
};

angular
    .module('pis-tool.module')
    .component('deleteVariableModal', deleteVariableModal);
  